import { createSlice } from '@reduxjs/toolkit';


const commonSlice = createSlice({
    name: 'common',
    initialState: {
        loader: {
            show: false,
        },
    },
    reducers: {
        showLoader: (state) => {
            state.loader.show = true;
        },
        hideLoader: (state) => {
            state.loader.show = false;
        },
    },
});


const { reducer, actions } = commonSlice;


export const { showLoader, hideLoader } = actions;


export const selectLoaderState = (state) => {
    return state.common.loader;
};


export default reducer;
